import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateExchangeSettingsDetails } from "../../redux/slices";
import { exchangeSettingsActionTypes } from "../../redux/utils";
import { useExchangeFetch, useHardCode } from "../../hooks";
import { Button, FullPageLoader, Toast } from "..";
import { useAppContext } from "../../contexts";
import { useAPI } from "../../hooks";
export const ExchangeOptionOtherItems = () => {
  const dispatch = useDispatch();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const price = isPureFemale
    ? PURE_FEMALE_TRANSLATION.exchange_option_other_items.price
    : storeConfigState?.themeConfig?.price;

  const { EXCHANGE_PRODUCT_VARIANTS } = useAPI();
  const {
    otherOptions,
    isExLoader,
    currentPage,
    dataFrom,
    dataTo,
    setCurrentPage,
    setPrevNextFlag,
    setChangeCurrentPageFlag,
    isInternalServerError,
  } = useExchangeFetch();

  const [activeItem, setActiveItem] = useState();
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [from, setFrom] = useState(dataFrom);
  const [to, setTo] = useState(dataTo);
  const [selectItemLoader, setSelectItemLoader] = useState(false);
  const navigate = useNavigate();

  const [exchangeSearchInputText, setexchangeSearchInputText] = useState("");
  const {
    exchangeSearchInput,
    setexchangeSearchInput,
  } = useAppContext();

  const buttonHandler = () => {
    setActiveItem(null);
    navigate("/ExchangeWithOtherItems");
  };

  const selectItemHandler = async (item) => {
    var variants = item;
    try {
      const response = await axios.post(EXCHANGE_PRODUCT_VARIANTS, {
          product_id: item.product_id,
          shop: storeConfigState.storeUniqueID,
          old_item_price: exchangeSettingsState.availableCredit,
      });
      if (response.data && response.data.length > 0) {
          variants = response.data[0];
      } } catch (error) {
        console.error("An error occurred:", error);
    }
    console.log(variants);
    if (activeItem === item.variant_id) {
      setIsBtnDisabled(true);
      setActiveItem(null);
    } else {
      //set
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_IMAGE,
          value: item.img_url,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
          value: item.name,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE,
          value: item.price,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE_CURRENCY,
          value: item.currency,
        })
      );

      setActiveItem(item.variant_id);

      item.variants.length > 0
        ? setIsBtnDisabled(false)
        : setIsBtnDisabled(true);

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_SELECTED_OTHER_VARIATION_OBJECT,
          value: variants,
        })
      );
    }
  };

  const changeCurrentPage = (flag) => {
    setPrevNextFlag(flag);
    if (flag === "next" && exchangeSettingsState.nextURL) {
      setCurrentPage((prev) => prev + 1);
      setChangeCurrentPageFlag((prev) => prev + 1);
    } else if (flag === "prev" && exchangeSettingsState.prevURL) {
      setChangeCurrentPageFlag((prev) => prev + 1);
      setCurrentPage((prev) => prev - 1);
    }
  };

  const backHandler = useCallback(() => {
    window.history.back();
  }, []);

  const handleexchangeSearchInputChange = (e) => {
    setexchangeSearchInputText(e.target.value);
    setCurrentPage(1);
  };

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      console.log('Enter');
      handleSearchButtonClick();
    }
  }

  function handleSearchButtonClick() {
    setexchangeSearchInput(exchangeSearchInputText);
    setCurrentPage(1);
  }

  const onClickSelectItem = async(item) => {
    setSelectItemLoader(true);
    await selectItemHandler(item);
    navigate("/ExchangeWithOtherItems");
    setSelectItemLoader(false);
  }
  
  useEffect(() => {
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_IS_EXCHANGE_OTHER,
        value: false,
      })
    );
  }, []);

  return (
    <main className="p2 choose">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara__container">
        <div className="saara-justify-content-center row__title">
          <Link to="" onClick={backHandler} className="btn__small_screen">
            <img src="assets/svg/chevron_left.svg" alt="back" />
          </Link>
          <div>
            <h1 className="p2__title saara-title">
              {storeConfigState?.themeConfig?.exchange_catalogue_left_title}
            </h1>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", border: "1px solid black", padding: "5px" }}>
              <label className="global__search">
                <svg className="global__search-icon">
                  <use xlinkHref="assets/svg/sprite.svg#search"></use>
                </svg>
                <input
                  className="global__search-input"
                  type="text"
                  placeholder="Search..."
                  value={exchangeSearchInputText}
                  onChange={handleexchangeSearchInputChange}
                  onKeyDown={handleKeyDown}
                />
              </label>
              <button
              style={{
                backgroundColor: "#1C2122",
                color: "white",
                border: "none",
                padding: "10px 15px",
                transition: "background-color 0.3s ease",
                cursor: "pointer",
              }}
                className="global__search-button"
                type="button"
                onClick={handleSearchButtonClick}
              >
                Search
              </button>
            </div>


              <div className="global__search-dropdown">
                <ul className="global__search-list"></ul>
              </div>
          </div>
        </div>
        <div className="p2__content">
          {isExLoader ? (
            <FullPageLoader />
          ) : (
            selectItemLoader ? <FullPageLoader /> :
            (<div className="saara-grid-4  p2__row">
              {otherOptions.slice(from, to).map((item, index) => {
                let isVariantInStock = false;
                isVariantInStock = item.variants.map((variant) => {
                  return variant.quantity >= 1 ? true : false;
                });
                isVariantInStock = isVariantInStock.includes(true);

                return (
                  <div
                    className="saara-box"
                    key={index}
                    onClick={() => {}}
                  >
                    <div
                      className={`p2__card card ${
                        activeItem === item.variant_id &&
                        (isVariantInStock ||
                          exchangeSettingsState.allowOutOfStock) &&
                        "active"
                      }`}
                    >
                      <span className="card__target">
                        <svg className="card__icon">
                          <use xlinkHref="assets/svg/sprite.svg#choose"></use>
                        </svg>
                      </span>
                      <div className="card__pic">
                        <img
                          src={item.img_url}
                          alt="wear"
                          className="saara__card__img"
                        />
                      </div>
                      <div className="card__info saara-card-margin-align">
                        <h2 className="card__title">{item.name}</h2>
                        <div
                          className="p2__card-info
                              exchange__card-info"
                        >
                          <p>
                            {price}:{" "}
                            <span
                              className="p2__card-price
                                      exchange__card-price"
                            >
                              {`${productDetailsState.currency}${item.price}`}
                            </span>
                          </p>
                          <div className=" saara-justify-content-center view-out-of-stock">
                            {!isVariantInStock &&
                              !exchangeSettingsState.allowOutOfStock && (
                                <span className="info__error error-items error-items-padding">
                                  {
                                    storeConfigState?.themeConfig
                                      ?.errors_product_out_of_stock
                                  }
                                </span>
                              )}
                          </div>
                          <div className="saara-justify-content-center view-details saara-flex-col">
                            {" "}
                            <a
                              href={`${storeConfigState.baseURL}/variants/${item.variant_id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {
                                storeConfigState?.themeConfig
                                  ?.exchange_catalogue_view_detail_label
                              }
                            </a>

                            <button 
                            className="saara-select-item-button"
                            onClick={() => onClickSelectItem(item)}>
                              Select item
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className="saara-pagination-button ">
          <div>
            <div className="btns btn-align">
              <div className="">
                <button
                  className="saara_custom_btn saara__btn btn__back back_page"
                  onClick={backHandler}
                >
                  {storeConfigState?.themeConfig?.back_button_label}
                </button>
              </div>
              <div className="btn__big-screen">
                <Button
                  name={storeConfigState?.themeConfig?.continue_button_label}
                  onClick={buttonHandler}
                  disabled={isBtnDisabled}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="global__pages pagination-main ">
              <Link
                to=""
                onClick={() => {
                  changeCurrentPage("prev");
                }}
                className={`prevArrow ${
                  exchangeSettingsState.prevURL ? "" : "arrowDisable"
                }`}
              >
                {" "}
                <img
                  className="pagination_chevron"
                  src="assets/left-arrow.png"
                  width="20"
                  alt="chevron-left"
                />
              </Link>

              <span className="pageNo">{currentPage}</span>

              <Link
                to=""
                onClick={() => {
                  changeCurrentPage("next");
                }}
                className={`nextArrow ${
                  exchangeSettingsState.nextURL ? "" : "arrowDisable"
                }`}
              >
                <img
                  className="pagination_chevron"
                  src="assets/right-arrow.png"
                  width="20"
                  alt="chevron-right"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
